import { Controller } from "@hotwired/stimulus"

// Sits on the hidden PDF file input. On change, submits the HTML-associated
// form (resolved via this.element.form) and visually marks the wrapping label
// as loading, since the LLM call runs synchronously and takes 10-30s.
export default class extends Controller {
  submit() {
    if (!this.element.files?.length) return

    this.showLoading()
    this.element.form?.requestSubmit()
  }

  showLoading() {
    const label = this.element.closest("label")
    if (label) {
      label.classList.add("opacity-60", "pointer-events-none", "cursor-wait")
      const span = label.querySelector("span")
      if (span) span.textContent = span.dataset.loadingText || `${span.textContent}…`
      const icon = label.querySelector("svg")
      if (icon) icon.classList.add("animate-spin")
    }
  }
}
